import React from "react";
import "./footer.scss";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faWhatsapp, faYoutube, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';


const Footer2 = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="section footer2">
      <div className="footer__header">
        <a href="/" className="footer__logo">
          <img src="https://res.cloudinary.com/dsnontai6/image/upload/v1758991862/Orter/Colored_2_Transparent_xsfkyj.png" alt="Fitness App Logo" className="footer__logo-image" />
        </a>
        <ul className="social">
          <li className="social__item">
            <Link to="#" target="_blank" rel="noreferrer" className="btn social">
              <FontAwesomeIcon icon={faXTwitter} />
            </Link>
          </li>
          <li className="social__item">
            <Link to="#" target="_blank" rel="noreferrer" className="btn social">
              <FontAwesomeIcon icon={faYoutube} />
            </Link>
          </li>
          <li className="social__item">
            <Link to="#" target="_blank" rel="noreferrer" className="btn social">
              <FontAwesomeIcon icon={faInstagram} />
            </Link>
          </li>
          <li className="social__item">
            <Link to="#" target="_blank" rel="noreferrer" className="btn social">
              <FontAwesomeIcon icon={faWhatsapp} />
            </Link>
          </li>
        </ul>
        <button type="button" className="btn icon" onClick={scrollToTop}>
          <FontAwesomeIcon icon={faChevronUp} />
        </button>
      </div>

      <ul className="footer__list">
        {[
          { name: "Home", path: "/" },
          { name: "Contact Us", path: "/contact-us" },
          { name: "Terms and conditions", path: "/terms-and-conditions" },
          { name: "Privacy and policy", path: "/privacy-policy" },
        ].map((link, idx) => (
          <li
            key={idx}
            className={`footer__item ${idx === 0 ? "active" : ""}`}
          >
            <Link to={link.path} className="footer__link">
              {link.name}
            </Link>
          </li>
        ))}
      </ul>

      <div className="footer__copyright">
        <p className="desc copyright">© All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer2;
